import React from 'react'
import WeightScalesSection from '../WeightScalesSection'
import RobotAndGripperLayout from './RobotAndGripperLayout'
import OrdersLayout from './OrdersLayout'
import SewageLayout from './SewageLayout'
import LockerLayout from './LockerLayout'
import PerInstanceRows from './PerInstanceRows'
import DoorsLayout from './DoorsLayout'
import { CommandsPayload, ControlGroupKey, SessionPayload } from '../types'

interface Props {
  commands: CommandsPayload | null
  session: SessionPayload
  sessionLoaded: boolean
  countdown: number
  sessionBusy: boolean
  onStartSession: () => void
  onFinishSession: () => void
}

const TRAY_COMMAND_ORDER = ['wash_tray']
const TRAY_FOOTER_COMMAND_ORDER = ['open_tray_door', 'close_tray_door']
const COOKER_COMMAND_ORDER = ['wash_cooker', 'release_cooker']

const groupCommands = (commands: CommandsPayload | null, key: ControlGroupKey) =>
  commands?.groups?.[key] ?? []

const CommandsLayout = ({
  commands,
  session,
  sessionLoaded,
  countdown,
  sessionBusy,
  onStartSession,
  onFinishSession,
}: Props) => (
  <>
    <div className="row g-3 mb-3">
      <div className="col-md-9 mb-3 mb-md-0">
        <RobotAndGripperLayout
          groupKey="robot_and_gripper"
          commands={groupCommands(commands, 'robot_and_gripper')}
          cardClassName="card h-100"
          session={session}
          commandsLoaded={commands !== null}
          sessionLoaded={sessionLoaded}
          countdown={countdown}
          sessionBusy={sessionBusy}
          onStartSession={onStartSession}
          onFinishSession={onFinishSession}
        />
      </div>

      <div className="col-md-3">
        <WeightScalesSection />
      </div>
    </div>

    <OrdersLayout groupKey="orders" commands={groupCommands(commands, 'orders')} />

    <LockerLayout
      groupKey="lockers"
      commands={groupCommands(commands, 'lockers')}
      lockerStates={commands?.locker_states ?? []}
    />

    <PerInstanceRows
      groupKey="cookers"
      commands={groupCommands(commands, 'cookers')}
      paramKey="cooker_number"
      commandOrder={COOKER_COMMAND_ORDER}
      gridClassName="controls-actions-grid-two"
    />

    <div className="row g-3 mb-3">
      <div className="col-md-9 mb-3 mb-md-0">
        <PerInstanceRows
          groupKey="tray"
          commands={groupCommands(commands, 'tray')}
          paramKey="tray_number"
          commandOrder={TRAY_COMMAND_ORDER}
          footerCommandOrder={TRAY_FOOTER_COMMAND_ORDER}
          gridClassName="controls-actions-grid-two"
        />
      </div>

      <div className="col-md-3">
        <SewageLayout
          groupKey="sewage"
          commands={groupCommands(commands, 'sewage')}
        />
      </div>
    </div>

    <DoorsLayout groupKey="doors" commands={groupCommands(commands, 'doors')} />
  </>
)

export default CommandsLayout
